import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import { fade} from '@material-ui/core/styles';

function BoxGroup({ items,ArtikelTagsList }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {items.length > 1 ? (
        <Badge
          color="primary"
          variant="dot"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '& .MuiBadge-badge': {
             fontSize: '10px',
            },
          }}
        >
                <Box
                    component="span"
                    style={{
                        backgroundColor: fade(ArtikelTagsList.find(item2=>parseInt(item2.id) === parseInt(items[0]) ).Color, 0.8),
                        color: '#fff',
                        fontSize:11,
                        padding:"2px 5px",
                        marginLeft:4,
                        borderRadius: 4,
                    }}>
                    {ArtikelTagsList.find(item2=>parseInt(item2.id) === parseInt(items[0]) ).Keyword}
                </Box>
        </Badge>
      ) : (
        items.map((item, index) => {
            let TaggObj = ArtikelTagsList.find(item2=>parseInt(item2.id) === item ) 
            return (
                <Box
                    component="span"
                    style={{
                        backgroundColor: fade(TaggObj.Color, 0.8),
                        color: '#fff',
                        fontSize:11,
                        padding:"2px 5px",
                        marginLeft:4,
                        borderRadius: 4,
                    }}>
                    {TaggObj.Keyword}
                </Box>
              )
        })
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleMouseLeave}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, display: 'flex', gap: 1 }}>
          {items.map((item, index) => {
            let TaggObj = ArtikelTagsList.find(item2=>parseInt(item2.id) === item ) 
            return (
                <Box
                    key={index}
                    component="div"
                    style={{
                        backgroundColor: fade(TaggObj.Color, 0.8),
                        color: '#fff',
                        fontSize:11,
                        padding:"2px 5px",
                        marginLeft:4,
                        borderRadius: 4,
                    }}>
                    {TaggObj.Keyword}
                </Box>
              )
          })}
        </Box>
      </Popover>
    </span>
  );
}

export default BoxGroup;
